import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import React from'react';import PropTypes from'prop-types';import styled from'styled-components';import {useIntl,FormattedMessage}from'react-intl';import {typography,useToggle}from'@manulife/mux';import Link from'../Link/Link.js';var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ExpandableParagraph__Wrapper",
  componentId: "sc-1lnrs2-0"
})(["margin:0.5rem 0 0.75rem;color:", ";font-weight:", ";font-size:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, typography.fontWeightLight, typography.fontSize);
var ExpandableParagraph = function ExpandableParagraph(_ref2) {
  var id = _ref2.id,
    collapsedContent = _ref2.collapsedContent,
    expandedContent = _ref2.expandedContent,
    showMoreButtonAriaLabel = _ref2.showMoreButtonAriaLabel,
    showLessButtonAriaLabel = _ref2.showLessButtonAriaLabel;
  var _useToggle = useToggle(false),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    expanded = _useToggle2[0],
    toggleExpanded = _useToggle2[1];
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("span", null, collapsedContent), "\xA0", expanded && /*#__PURE__*/React.createElement("span", {
    id: "".concat(id, "-expand")
  }, expandedContent), /*#__PURE__*/React.createElement(Link, {
    onClick: toggleExpanded,
    "aria-label": expanded ? showLessButtonAriaLabel : showMoreButtonAriaLabel,
    "aria-expanded": expanded ? 'true' : 'false',
    "aria-describedby": "".concat(id, "-expand"),
    analyticsData: {
      click: {
        linkName: intl.formatMessage({
          id: "shared.expandableParagraph.".concat(expanded ? 'showLess' : 'showMore')
        })
      }
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "shared.expandableParagraph.".concat(expanded ? 'showLess' : 'showMore')
  })));
};
process.env.NODE_ENV !== "production" ? ExpandableParagraph.propTypes = {
  id: PropTypes.string.isRequired,
  collapsedContent: PropTypes.node.isRequired,
  expandedContent: PropTypes.node.isRequired,
  showMoreButtonAriaLabel: PropTypes.string.isRequired,
  showLessButtonAriaLabel: PropTypes.string.isRequired
} : void 0;
var ExpandableParagraph$1 = ExpandableParagraph;export{ExpandableParagraph$1 as default};